import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/spinner/index.tsx
import React from "react";
var Spinner = ({ className }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className: cn("h-full w-full", className),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    "data-testid": "spinner"
  },
  /* @__PURE__ */ React.createElement("g", { fill: "none", strokeLinecap: "round", stroke: "currentColor" }, /* @__PURE__ */ React.createElement("circle", { strokeWidth: "10", className: "opacity-25", cx: "50", cy: "50", r: "45" }), /* @__PURE__ */ React.createElement(
    "circle",
    {
      strokeWidth: "10",
      className: "animate-spinner",
      cx: "50",
      cy: "50",
      r: "45"
    }
  ))
);

export {
  Spinner
};
